import React from 'react';
import Modal from 'react-bootstrap/Modal'
import { postRequest } from '../http'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import { ModI } from './modal_i.styled';
import { storage } from '../firebase_config'
import { getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import { z, ZodError} from 'zod'
import {v4 as uuidv4} from 'uuid'


export default function ModalItem(props) {
  


  
  const [file, setFile] = React.useState('')
  const [imgUrl, setImgUrl]= React.useState('')
  const [name, setName] = React.useState('')
  const [type, setType] = React.useState('')
  const [disc, setDisc] = React.useState('')
  const [errors, setErrors] = React.useState({})
  const [prize, setPrize] = React.useState(0)
  const [category, setCategory] = React.useState('')
  const keys = Object.keys(errors)
  const [imgId, setImgId] = React.useState('')
  const subimgs ={
    Drinks: 'https://www.svgrepo.com/show/286022/drink-soda.svg',
    Food: 'https://www.svgrepo.com/show/31361/chinese-food.svg',
    Tobacco: 'https://www.svgrepo.com/show/210379/smoker.svg',
    Bookings: 'https://www.svgrepo.com/show/26572/balloons.svg'

  }
    
  
    async function onImage(event) {
         
      setFile( event.target.files[0] )
      setImgId(`images/${uuidv4()}`)
  }
  
     const reader = new FileReader();
     reader.onload = ()=> {
        setImgUrl(reader.result) 
        
     }
     if (file) {
         reader.readAsDataURL(file);
     };
  
    
     async function addItem(event) {
       
       event.preventDefault()
       
       try {

        const itemValidater = z.object({
          type: z.string().min(2,{message: "This Field Is Required"}),
          name: z.string().min(2,{message: "This Field Is Required"}),
          description: z.string().nullable(),
          category: z.string().min(2,{message: "This Field Is Required"}),
          prize: z.number().min(1,{message: "This Field Is Required"}),
          image_url: z.string().url()
          
         })
        itemValidater.parse({
          userId: localStorage.getItem('user'),
          name: name,
          type: type,
          description: disc,
          category: category,
          prize: prize,
          image_url: subimgs.Food
        })
        setErrors('none')
        const images = ref(storage, imgId )
        if (file) {
          await uploadBytes(images, file)
        }
        

       
        
        const url = file ? await getDownloadURL(images) : subimgs[type]
        
        const item ={
          
          name: name,
          desc: disc,
          type: type,
          category: category,
          price: prize,
          image_url: url,
          image_id: imgId ? imgId : 'none'
          
         }
        postRequest('/set_item', item, (resp)=>{
          console.log(resp.data)
        }).finally(()=>{
          setName('')
          setDisc('')
          setPrize(0)
          setType('')
          setCategory('')
          setErrors('none')
          props.reloadData(Date.now())
        })
        console.log(url)
      
       } catch (error) {
        if (error instanceof ZodError){
          setErrors(error.flatten().fieldErrors)
        }else{
          console.log( error.message)
        }
        
       }
       
      
       
     }
    
    return (
      <div>
        
        <Modal
        {...props}
        size='lg'
        aria-labelledby="contained-modal-title-vcenter"
        centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Create An Item
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
          <ModI>
            
          <div style={{textAlign: 'center', color: 'darkslategrey' }}><i>{file?.name}</i> </div>
            <div className="img">
            <div>
            <img src={imgUrl} alt=""  />
            </div>
            </div>
            <div className="choose">
            <Button variant='secondary' as='label' htmlFor="file" >
            Choose Image
            </Button>
             <input  style={{display: 'none'}} onChange={onImage}  type="file" accept='image/png, image/jpeg' name="file" id="file" />
            </div>
           
           
            
            <div className="fields">
            <div>
            <label htmlFor="">Name:</label>
            <Form.Control isInvalid={keys.includes('name')} isValid={keys.length === 0 ? false :!keys.includes('name')} onChange={(event)=>setName(event.target.value)} value={name} placeholder='Item Name' type="text"  />
            <div className='err2' >{errors?.name?.at(0)}</div>
            </div>
            <div>
            <label htmlFor="">Description:</label>
            <Form.Control isInvalid={keys.includes('description')} isValid={keys.length === 0 ? false :!keys.includes('description')} as={'textarea'} onChange={(event)=>setDisc(event.target.value)} value={disc} placeholder='Description' style={{marginBottom: '0px'}}  />
            <div className='err2' >{errors?.description?.at(0)}</div>
            </div>
            <div className="bott-end">
             <div style={{marginRight: '20px'}}><label htmlFor="">Prize:</label>
            <Form.Control isInvalid={keys.includes('prize')} isValid={keys.length === 0 ? false :!keys.includes('prize')} onChange={(event)=>setPrize(event.target.valueAsNumber)} value={prize} placeholder='Prize' type="number"  />
            <div className='err2' >{errors?.prize?.at(0)}</div>
            </div>
            <div>
            <label htmlFor="">Item Type</label>
            <Form.Select as='select' isInvalid={keys.includes('type')} isValid={keys.length === 0 ? false :!keys.includes('type')} onChange={(event)=>setType(event.target.value)} value={type} >
              <option value="">Category</option>
              <option value="Food">Food</option>
              <option value="Drinks">Drinks</option>
              <option value="Tobacco">Tobacco</option>
              <option value="Bookings">Bookings</option>
            </Form.Select>
            <div className='err2' >{errors?.category?.at(0)}</div>
            </div>
            </div>
            <div>
              <label htmlFor="">Category:</label>
              <Form.Control isInvalid={keys.includes('category')} isValid={keys.length === 0 ? false :!keys.includes('category')} onChange={(event)=>setCategory(event.target.value)} value={category} placeholder='Item Name' type="text"  />
              <div className='err2' >{errors?.name?.at(0)}</div>
            </div>
            </div>
            <div className="btns">
            
            <Button variant='success' onClick={addItem} style={{marginLeft: '16px'}} >Save</Button>
          </div>
          </ModI>
          </Modal.Body>

        </Modal>
      </div>
    );
}